var render, staticRenderFns
import script from "./wrap.vue?vue&type=script&lang=tsx&"
export * from "./wrap.vue?vue&type=script&lang=tsx&"
import style0 from "./wrap.vue?vue&type=style&index=0&id=579cb9d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cb9d3",
  null
  
)

export default component.exports